__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "mattermost-webapp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@hello-pangea/dnd", "18.0.1", () => (Promise.all([__webpack_require__.e(4964), __webpack_require__.e(1929), __webpack_require__.e(7), __webpack_require__.e(7270), __webpack_require__.e(7153)]).then(() => (() => (__webpack_require__(44964))))));
			register("@mattermost/client", "12.0.2", () => (Promise.all([__webpack_require__.e(183), __webpack_require__.e(6612)]).then(() => (() => (__webpack_require__(96612))))));
			register("history", "4.10.1", () => (__webpack_require__.e(3861).then(() => (() => (__webpack_require__(93861))))));
			register("luxon", "3.6.1", () => (__webpack_require__.e(6195).then(() => (() => (__webpack_require__(66195))))));
			register("react-bootstrap", "github:mattermost/react-bootstrap#d693ec8082954f0e6d3e826ca6161979b29001cd", () => (Promise.all([__webpack_require__.e(1524), __webpack_require__.e(3460), __webpack_require__.e(1929), __webpack_require__.e(7), __webpack_require__.e(1633)]).then(() => (() => (__webpack_require__(3460))))));
			register("react-dom", "19.2.8", () => (Promise.all([__webpack_require__.e(1929), __webpack_require__.e(8325)]).then(() => (() => (__webpack_require__(78325))))));
			register("react-intl", "*", () => (Promise.all([__webpack_require__.e(2821), __webpack_require__.e(1929)]).then(() => (() => (__webpack_require__(62821))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(5022), __webpack_require__.e(1929)]).then(() => (() => (__webpack_require__(85022))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(7896), __webpack_require__.e(1929), __webpack_require__.e(893)]).then(() => (() => (__webpack_require__(47896))))));
			register("react", "19.2.8", () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__(63696))))));
			register("styled-components", "5.3.7", () => (Promise.all([__webpack_require__.e(1459), __webpack_require__.e(1929), __webpack_require__.e(8538)]).then(() => (() => (__webpack_require__(51459))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};